function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onCancel", "onOk"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import useList from "../../../../utils/hooks/useList";
import { SearchOutlined } from '@ant-design/icons';
import { useDrawerMethod, useMount } from '@micun/form';
import { Input } from 'antd';
import cls from 'classnames';
import { debounce } from 'lodash';
import { useState } from 'react';
import { useCssInJs } from "../../../../hooks";
import "../../customAntdStyles/custom-antdesign-styles.css";
import { getSubTaskListPageStyle } from "./styles";
import { SubTaskList } from "./subTaskList";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NAME_MAP = {
  totalCount: '全部',
  processingCount: '处理中',
  finishedCount: '已完成',
  suspendCount: '已终止'
};
var STATUS_KEY_MAP = {
  totalCount: undefined,
  processingCount: 'PROCESSING',
  finishedCount: 'FINISHED',
  suspendCount: 'SUSPEND'
};
var SubTaskListDrawer = function SubTaskListDrawer(params) {
  var onCancel = params.onCancel,
    onOk = params.onOk,
    rest = _objectWithoutProperties(params, _excluded);
  var _useDrawerMethod = useDrawerMethod(),
    render = _useDrawerMethod.render,
    setOpen = _useDrawerMethod.setOpen;
  return render({
    onClose: function onClose() {
      setOpen(false);
      onCancel();
    },
    title: '流程详情',
    width: 570,
    className: 'ec-task-drawer',
    children: /*#__PURE__*/_jsx(SubTaskListPage, _objectSpread({}, rest))
  });
};
export var useSubTaskListDrawer = function useSubTaskListDrawer() {
  var mount = useMount();
  return function (params) {
    return new Promise(function (resolve, reject) {
      var drawer = mount( /*#__PURE__*/_jsx(SubTaskListDrawer, _objectSpread(_objectSpread({}, params), {}, {
        onOk: resolve,
        onCancel: reject
      })));
    });
  };
};

// 子流程列表
export default function SubTaskListPage(props) {
  var _props$data;
  var prefix = 'sub-task-list-page';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getSubTaskListPageStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var taskOrderId = props === null || props === void 0 || (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.taskOrderId;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeKey = _useState2[0],
    setActiveKey = _useState2[1];
  var _useState3 = useState({
      totalCount: 0,
      processingCount: 0,
      finishedCount: 0,
      suspendCount: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    countData = _useState4[0],
    setCountData = _useState4[1];
  var listData = useList({
    method: 'get',
    url: '/flow/core/query/order/subFlowOrder',
    initialPage: {
      size: 20
    },
    initialQuery: {
      taskOrderId: taskOrderId,
      orderStatus: activeKey
    },
    responseFilter: function responseFilter(resData) {
      var res = resData;
      var finishedCount = res.finishedCount,
        processingCount = res.processingCount,
        suspendCount = res.suspendCount,
        totalCount = res.totalCount;
      setCountData({
        totalCount: totalCount,
        processingCount: processingCount,
        finishedCount: finishedCount,
        suspendCount: suspendCount
      });
      var pagerRes = res.flowOrders;
      return pagerRes;
    }
  });
  var data = listData.data,
    isEmpty = listData.isEmpty;
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    focus = _useState6[0],
    setFocus = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    text = _useState8[0],
    setText = _useState8[1];
  var handleChange = function handleChange(e) {
    var nextText = e.target.value;
    setText(nextText);
    var keyword = nextText.trim();
    if ((text === null || text === void 0 ? void 0 : text.trim()) !== keyword) {
      fetchSearchData(keyword);
    }
  };
  var fetchSearchData = debounce(function (keyword) {
    listData.handleQuery(_objectSpread(_objectSpread({}, listData.query), {}, {
      flowOrderName: keyword || undefined
    }));
  }, 500);

  // if (isEmpty) {
  //   return null
  // }

  return wrapSSR( /*#__PURE__*/_jsxs("div", {
    className: cls(prefix, hashId),
    children: [/*#__PURE__*/_jsx("div", {
      className: "searchInputWrap",
      children: /*#__PURE__*/_jsx(Input, {
        placeholder: "\u641C\u7D22\u6D41\u7A0B\u540D\u79F0",
        className: "searchInput",
        allowClear: true,
        suffix: /*#__PURE__*/_jsx(SearchOutlined, {}),
        onChange: handleChange
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "countView",
      children: Object.keys(countData).map(function (key, i) {
        var keyVal = STATUS_KEY_MAP[key];
        var activated = activeKey === keyVal;
        return /*#__PURE__*/_jsxs("div", {
          className: cls('countItem', {
            active: activated
          }),
          onClick: function onClick() {
            setActiveKey(keyVal);
            listData.handleQuery(_objectSpread(_objectSpread({}, listData.query), {}, {
              orderStatus: keyVal
            }));
          },
          children: [/*#__PURE__*/_jsx("div", {
            className: "name",
            children: NAME_MAP[key]
          }), /*#__PURE__*/_jsx("div", {
            className: "count",
            children: countData[key] || 0
          })]
        }, key);
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "subTaskListWrap",
      children: /*#__PURE__*/_jsx(SubTaskList, {
        data: data
      })
    })]
  }));
}